import React from "react";
import InvestorSection from "../../components/Investor/Investor.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Investor = () => {
  return (
    <>
      <MetaComponent
        title="Investor Relations & Global Education Sector Insights | Aptech Limited Official Investor Page"
        desc="Access Aptech Limited’s investor relations platform for financial insights, market updates, governance information, and global education sector trends."
        keywords="Investor news of Aptech, Aptech Investor Relations, Investor Policies"
      />

      <InvestorSection />
    </>
  );
};

export default Investor;
